export default "__VITE_ASSET__10f2c0d8__"